import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getContentItemType} from "./__graphql-types__/index.ts";

export const CONTENT_ITEM_QUERY: GqlOperation<
    getContentItemType["response"],
    getContentItemType["variables"]
> = gqlOp(gql`
    query getContentItem($descriptors: [String!]!, $kaRegion: String!) {
        contentForDescriptors(descriptors: $descriptors) {
            id
            contentDescriptor
            contentKind
            translatedTitle
            translatedDescription
            mappedStandards(region: $kaRegion) {
                id
                setId
                standardId
            }
            lesson: parentTopic {
                id
                translatedTitle
                unit: parent {
                    id
                    translatedTitle
                    course: parent {
                        id
                        translatedTitle
                    }
                }
            }
        }
    }
`);
